const t = {
  name: "FundsOut",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0H6V2H18V0Z" fill="currentColor"/>
<path d="M11.9999 7.58578L17.4141 13L15.9999 14.4142L13 11.4143V20H11V11.4141L7.99991 14.4142L6.58569 13L11.9999 7.58578Z" fill="currentColor"/>
<path d="M6 4H18V6H6V4Z" fill="currentColor"/>
<path d="M4 21V8H2V21C2 22.6523 3.34772 24 5 24H19C20.6523 24 22 22.6523 22 21V8H20V21C20 21.5477 19.5477 22 19 22H5C4.45228 22 4 21.5477 4 21Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as FundsOut
};
